import { useInHouseJackpot } from '../../../../../hooks';
import { JackpotMobile } from '../JackpotMobile';

import styles from './index.module.css';

export const JackpotMobileWidget = () => {
  useInHouseJackpot(true);

  return (
    <div className={styles.jackpotMobileWidget}>
      <JackpotMobile />
    </div>
  );
};
